/***
 *
 *   MOBILE BOTTOM BAR STYLES
 *   Ported from ui-reference/src/components/layouts/mobile-bottom-bar.tsx.
 *
 *   Lives inside the inset content card (not `fixed` over the primary
 *   frame). `pb-[env(safe-area-inset-bottom,0px)]` keeps the row clear of
 *   the iOS home indicator.
 *
 *   NOTE on `text-accent-500`: that is the reference's active colour and is
 *   copied as-is, but accent-500 is a LIGHT indigo (hsl 238 82% 71%) and sits
 *   on `bg-surface`, which is white in light mode. It does not clear WCAG AA
 *   for text at this size. Flagged for the Phase 12 contrast audit rather than
 *   diverged from here, so the shell matches the reference first.
 *
 **********/

const Style = {
    bar: `flex shrink-0 border-t bg-surface
    pb-[env(safe-area-inset-bottom,0px)] md:hidden`,

    item: `flex flex-1 flex-col items-center gap-1 py-2 text-[10px] font-medium
    transition-colors duration-150
    focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring`,
    itemActive: 'text-accent-500',
    itemIdle: 'text-text-secondary hover:text-text-primary',

    label: 'max-w-full truncate px-1',
};

export default Style;
